import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Toast configuration object
const toastConfig = {
  position: "top-left",
  autoClose: 3500,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: "colored",
  style: {
    top: "12px", // Same as your toolbar
    left: "12px",
    right: "auto",
    width: "auto",
    maxWidth: "400px",
    fontSize: "13px",
    borderRadius: "6px",
    minHeight: "32px",
  },
};

// Success toast with custom styling
export const showSuccessToast = (message, options = {}) => {
  return toast.success(message, {
    ...toastConfig,
    autoClose: 1400,
    style: {
      background: "#005A86",
      color: "white",
      padding: "6px 12px",
      fontSize: "13px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      minHeight: "32px",
      ...options.style,
    },
    icon: false,
    ...options,
  });
};

// Error toast
export const showErrorToast = (message, options = {}) => {
  return toast.error(message, {
    ...toastConfig,
    style: {
      background: "#d32f2f",
      color: "white",
      padding: "6px 12px",
      fontSize: "13px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      minHeight: "32px",
      ...options.style,
    },
    icon: false,
    ...options,
  });
};

// Info toast
export const showInfoToast = (message, options = {}) => {
  return toast.info(message, {
    ...toastConfig,
    autoClose: 2000,
    style: {
      background: "#1976d2",
      color: "white",
      padding: "6px 12px",
      fontSize: "13px",
      borderRadius: "6px",
      boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
      minHeight: "32px",
      ...options.style,
    },
    icon: false,
    ...options,
  });
};



// Toast container component
const ToastNotification = () => {
  return (
    <ToastContainer
      position="top-right"
      autoClose={3500}
      hideProgressBar
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="colored"
      style={{
        top: "12px",
        right: "12px",
        width: "auto",
        maxWidth: "400px",
      }}
    />
  );
};

export default ToastNotification;
